var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 0C13.0344 0 15.5619 2.10844 16.1294 4.90425C18.2902 5.05456 20.0002 6.7925 20.0002 8.9375C20.0002 11.1808 18.1344 13 15.8336 13H5.00024C2.23858 13 0.000244141 10.8176 0.000244141 8.125C0.000244141 5.61112 1.95274 3.5425 4.46024 3.27925C5.50274 1.33169 7.59024 0 10.0002 0ZM13.4559 6.61862L10.0009 3.25L6.54504 6.61862C6.28254 6.87456 6.46921 7.3125 6.84004 7.3125H8.33421V10.1562C8.33421 10.3805 8.52087 10.5625 8.75087 10.5625H11.2509C11.4809 10.5625 11.6675 10.3805 11.6675 10.1562V7.3125H13.1617C13.5325 7.3125 13.7184 6.87456 13.4559 6.61862Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.07977811d0bd32aa629361f08e0419e6.svg";
export { ForwardRef as ReactComponent };